<template>
	<div v-if="data && data.dataField && layoutID">
		<div>{{ $t(`i18nLayout.${layoutID}`)[`${data.dataField}`] }}</div>
	</div>
</template>
<script>
export default {
	name: 'configLayoutFieldNameTemplate',
	props: {
		data: {},
		column: {},
		layoutID: {
			default: '',
			type: String,
		},
	},
	created() {},
	computed: {},
	methods: {},
};
</script>
<style lang="scss" scoped>
</style>

